import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { CatHeading } from '@blocks-react/components/Heading';
import { FC } from 'react';

type TitleProps = {
  title: string;
  label: string;
};

export const DcnTitle: FC<TitleProps> = ({ title = '', label = '' }) => (
  <div className="mb-4">
    <CatTextPassage tabIndex={0}>
      <div className="mb-1">
        <CatHeading variant="footnote">{title}</CatHeading>
      </div>
      <CatHeading variant="label">{label}</CatHeading>
    </CatTextPassage>
  </div>
);
